

import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import moment from 'moment-timezone';

import "@/store/modules/information";
const informationState = namespace("Information");

import "@/store/modules/common";
const commonState = namespace("Common");

import "@/store/modules/forms/form11";
const form11State = namespace("Form11");


import { form11DataInfoType, form11PartiesInfoType } from '@/types/Information/Form11';
import { partiesDataJsonDataType, previousCourtJsonInfoType } from '@/types/Information/json';

import AddPartyForm from './AddPartyForm.vue';
import AddJudgeForm from './AddJudgeForm.vue';
import AddPartyModal from './AddPartyModal.vue';
import { hearingLocationsInfoType } from '@/types/Common';
import {justiceNames} from '@/components/utils/JusticeName';

@Component({
    components:{        
        AddJudgeForm,
        AddPartyForm,
        AddPartyModal        
    }
})
export default class Form11StyleOfProceeding extends Vue {

    @informationState.State
    public partiesJson: partiesDataJsonDataType;   

    @informationState.State
    public fileNumber: string;

    @commonState.State
    public hearingLocationsInfo!: hearingLocationsInfoType[];

    @form11State.State
    public currentOrder: previousCourtJsonInfoType;

    @form11State.State
    public form11Info: form11DataInfoType;

    @form11State.Action
    public UpdateForm11Info!: (newForm11Info: form11DataInfoType) => void  
    
    @form11State.State
    public currentOrderMultipleJusticesId: string;

    @form11State.Action
    public UpdateCurrentOrderMultipleJusticesId!: (newCurrentOrderMultipleJusticesId: string) => void
    
    dataReady = false;
    updated=0; 
    updateOrderDetails = 0;
    orderDateValue = '';
  
    addRespondentFormColor = 'court';
    AddNewRespondentForm = false;

    addAppellantFormColor = 'court';
    AddNewAppellantForm = false;

    partyNames: form11PartiesInfoType[] = [];

    addJudgeNamesFormColor = 'court';
    AddNewJudgeNamesForm = false;
    latestEditJudgeNamesData;
    isEditJudgeNamesOpen = false;

    hearingLocationList: string[] = [];
    otherHearingLocationList: string[] = [];
    hearingLocation = "";
    otherHearingLocation = "";

    partyToEdit = {} as form11PartiesInfoType;
    showPartyWindow = false
    isCreate = true
    partyType = ''
    
    invalidSuccessfulParties=false
    nonSuccessfulPartyNames: form11PartiesInfoType[]= []

    allowedOptions = [
        {text: 'Allowed', value: true},
        {text: 'Dismissed', value: false}
    ];

    yesNoOptions = [
        {text: 'Yes', value: true},
        {text: 'No', value: false}
    ]; 

    partyFields = [
        { key:'organization', label:'Party Type', thClass: 'text-white bg-court', thStyle: '', sortable:false }, 
        { key:'name', label:'Party Name', thClass: 'text-white bg-court', thStyle: '',  sortable:false  },
        { key:'counselName', label:'Counsel Name', thClass: 'text-white bg-court', thStyle: '',  sortable:false  },
        { key:'edit', label:'', thClass: 'text-white bg-court', sortable:false }        
    ]

    judgeFields = [
        { key:'name', label:'Name', thClass:'text-white bg-court', thStyle: 'font-size: 1rem;', sortable:false },
        { key:'other',label:'', thClass:'text-white bg-court', thStyle: 'font-size: 1rem;', sortable:false},         
        { key:'edit', label:'', thClass: 'text-white bg-court', sortable:false}
    ]

    state = { 
        appellantsInfo: null,
        respondentsInfo: null,
        judgeNames: null,        
        hearingLocation: null,
        hearingLocationOther: null,     
        dateOfJudgement: null, 
        varyingOrderJudgeName: null,
        // varyingOrderJudgeNameOther: null,
        varyingOrderDate: null,
        filingParties: null,
        appearingParties: null,
        orderAllowed: null,
        otherOrders: null,
        furtherOrders: null,
        varyingOrderLocation: null,
        judgmentReserved: null,
        hearingHeldDate: null,
        laterDateDecided: null,
        laterDate: null,
        supplementaryReasons: null,
        hearingDate: null,
        ordersCourtMade: null,
        orderedAwardingCosts: null,
        supplementaryReasonsDate: null,
        successfulParties: null,
        unsuccessfulParties: null,
    }

    justiceNameOptions = [];
    created(){
        this.justiceNameOptions = justiceNames
    }

    mounted() {
        this.dataReady = false;        
        this.extractInfo();              
    }
    
    public extractInfo(){
        
        this.extractHearingLocations()

        if(this.currentOrderMultipleJusticesId){
            this.getForm11Data();
           
        } else { 

            const form11Data = this.form11Info;            
            form11Data.version = this.$store.state.Application.version;
            form11Data.judgeNames = [];
            form11Data.appellants = this.partiesJson.appellants
            form11Data.respondents = this.partiesJson.respondents
            form11Data.formSevenNumber = this.fileNumber; 
            form11Data.appearingParties = [];
            form11Data.filingParties = []; 
            form11Data.successfulParties = [];
            form11Data.unsuccessfulParties = [];          
            form11Data.previousCourts = this.currentOrder;
            this.UpdateForm11Info(form11Data);
            this.initHearingLocation()
            this.revaluateForm11Data()
            this.extractJudgeNames()
            this.updateNonSuccessfulParties()
            this.saveForm(true);
        }          
    }

    public extractJudgeNames(){
        const currentOrder = this.form11Info.previousCourts
        const judgeName = currentOrder && currentOrder.JudgeLastName? (
            (currentOrder.JudgeSalutation? currentOrder.JudgeSalutation+' ':'Justice ')+
            (currentOrder.JudgeLastName)
        ).trim() : ''

        if(judgeName){
            // const justiceIndex = justiceNames.findIndex(name=> name.toLowerCase().includes(judgeName.toLowerCase()))
            // if(justiceIndex>-1){
            //     this.form11Info.varyingOrderJudgeName=justiceNames[justiceIndex]
            //     this.form11Info.varyingOrderJudgeNameOther=''                
            // }
            // else{
            //     this.form11Info.varyingOrderJudgeName='Other'
            //     this.form11Info.varyingOrderJudgeNameOther=judgeName
            // }
            this.form11Info.varyingOrderJudgeName=judgeName;
            this.form11Info.varyingOrderDate= currentOrder.JudgmentDate.slice(0,10)            
            this.form11Info.varyingOrderLocation = currentOrder.Location? currentOrder.Location: ''
        }
        else{
            this.form11Info.varyingOrderJudgeName='';
            //this.form11Info.varyingOrderJudgeNameOther='';
            this.form11Info.varyingOrderDate='';
            this.form11Info.varyingOrderLocation ='';
        }
        this.UpdateForm11Info(this.form11Info);
    } 

    public extractHearingLocations(){
        this.hearingLocationList = [];
        
        for (const hearingLocation of this.hearingLocationsInfo){
            if (hearingLocation.other)
                this.otherHearingLocationList.push(hearingLocation.name);
            else 
                this.hearingLocationList.push(hearingLocation.name);                
        }
        this.hearingLocationList.push('Other');
    }
    
    public initHearingLocation(){
        this.hearingLocation = this.form11Info.hearingLocation?.name
        if(this.otherHearingLocationList.includes(this.hearingLocation)){
            this.hearingLocation ='Other'
            this.otherHearingLocation = this.form11Info.hearingLocation.name
        }
    }

    public updateHearingLocation(){ 
              
        const form11 = this.form11Info;       
        form11.hearingLocation = {} as hearingLocationsInfoType;
       
        if (this.hearingLocation == 'Other' && this.otherHearingLocation.length > 0){
            form11.hearingLocation = this.hearingLocationsInfo.filter(location => location.name == this.otherHearingLocation)[0]
        } else if (this.hearingLocation != 'Other') {
            form11.hearingLocation = this.hearingLocationsInfo.filter(location => location.name == this.hearingLocation)[0]
        }  
        
        this.UpdateForm11Info(form11);
        this.recheckStates()
    }

    public revaluateForm11Data(){

        const form11Data = this.form11Info;

        for (const respondent of form11Data.respondents){
            if (respondent.firstName && respondent.lastName){                    
                respondent.isOrganization = false;
            } else if (respondent.organization){
                respondent.isOrganization = true;
            }
            if(respondent.solicitor?.counselFirstName && respondent.solicitor?.counselLastName)
                respondent.counselName = respondent.solicitor.counselFirstName+' '+respondent.solicitor.counselLastName                          
            respondent.responding = true;
        }

        for (const applicant of form11Data.appellants){
            if (applicant.firstName && applicant.lastName){
                applicant.isOrganization = false;
            } else if (applicant.organization){
                applicant.isOrganization = true;
            }
            if(applicant.solicitor?.counselFirstName && applicant.solicitor?.counselLastName)
                applicant.counselName = applicant.solicitor.counselFirstName+' '+applicant.solicitor.counselLastName             
            applicant.responding = false;
        }

        const appellants = form11Data.appellants.map(resp=>resp.name)
        const respondents = form11Data.respondents.map(resp=>resp.name)
        form11Data.appellantNames = appellants.join(', ');
        form11Data.respondentNames = respondents.join(', ');

        this.partyNames = [...form11Data.appellants, ...form11Data.respondents]
        this.UpdateForm11Info(form11Data);
    }

    public getForm11Data() {        
       
        this.$http.get('/form11/forms/'+this.currentOrderMultipleJusticesId)
        .then((response) => {
            if(response?.data?.data){
                const form11Data = response.data.data
                this.UpdateForm11Info(form11Data);
                this.revaluateForm11Data()
                this.initHearingLocation()
                this.clearStates();
                this.updateNonSuccessfulParties()               
            }                
        },(err) => {
            console.log(err)        
        });      
    }

    public clearStates(){
        this.state = {
            appellantsInfo: null,
            respondentsInfo: null,
            judgeNames: null,        
            hearingLocation: null,
            hearingLocationOther: null,     
            dateOfJudgement: null,
            varyingOrderJudgeName: null,
            //varyingOrderJudgeNameOther: null,
            varyingOrderLocation: null,
            varyingOrderDate: null,
            filingParties: null,
            appearingParties: null,
            orderAllowed: null,
            otherOrders: null,
            furtherOrders: null,            
            judgmentReserved: null,
            hearingHeldDate: null,
            laterDateDecided: null,
            laterDate: null,
            supplementaryReasons: null,
            supplementaryReasonsDate: null,
            hearingDate: null,
            ordersCourtMade: null,
            orderedAwardingCosts: null,
            successfulParties: null,
            unsuccessfulParties: null
        }
        this.dataReady = true; 
    }

    public recheckStates(dontFindInvalidFields?){
        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                this.checkStates(dontFindInvalidFields)
                return 
            }
        }
    }

    public checkStates(dontFindInvalidFields?){  
        
        this.state.appellantsInfo = this.form11Info.appellants?.length>0? null :false;
        this.state.respondentsInfo = this.form11Info.respondents?.length>0? null :false;            
        this.state.judgeNames = this.form11Info.judgeNames?.length>0? null :false;
        
        this.state.hearingLocation =  this.hearingLocation? null :false
        this.state.hearingLocationOther =  this.hearingLocation=='Other' && !this.otherHearingLocation? false :null
        
        this.state.dateOfJudgement = this.form11Info.dateOfJudgement? null: false;
        this.state.varyingOrderJudgeName = this.form11Info.varyingOrderJudgeName? null :false;
        //this.state.varyingOrderJudgeNameOther = this.form11Info.varyingOrderJudgeName=='Other' && !this.form11Info.varyingOrderJudgeNameOther? false: null;
        this.state.varyingOrderLocation = this.form11Info.varyingOrderLocation? null :false;
        this.state.varyingOrderDate = this.form11Info.varyingOrderDate? null :false;
        this.state.filingParties = this.form11Info.filingParties?.length>0? null :false;
        this.state.appearingParties = this.form11Info.appearingParties?.length>0? null :false;
        this.state.orderAllowed = this.form11Info.orderAllowed == true || this.form11Info.orderAllowed ==false? null :false;
        this.state.otherOrders = this.form11Info.otherOrders == true || this.form11Info.otherOrders ==false? null :false;
        this.state.furtherOrders = this.form11Info.otherOrders == true && !this.form11Info.furtherOrders? false :null

        this.state.judgmentReserved = this.form11Info.judgmentReserved == true || this.form11Info.judgmentReserved ==false? null :false;
        this.state.hearingHeldDate = this.form11Info.judgmentReserved && !this.form11Info.judgmentReservedDate? false :null
        this.state.laterDateDecided = this.form11Info.laterDateDecided == true || this.form11Info.laterDateDecided ==false? null :false;
        this.state.laterDate = this.form11Info.laterDateDecided && !this.form11Info.laterDate? false :null
        this.state.supplementaryReasons = this.form11Info.supplementaryReasons == true || this.form11Info.supplementaryReasons ==false? null :false;
        this.state.supplementaryReasonsDate = this.form11Info.supplementaryReasons && !this.form11Info.supplementaryReasonsDate? false :null
        this.state.orderedAwardingCosts = this.form11Info.orderedAwardingCosts == true || this.form11Info.orderedAwardingCosts ==false? null :false;
        this.state.successfulParties = this.form11Info.orderedAwardingCosts && (this.invalidSuccessfulParties || this.form11Info.successfulParties?.length==0) ?false : null
        this.state.unsuccessfulParties = this.form11Info.orderedAwardingCosts && this.form11Info.unsuccessfulParties?.length==0 ? false : null
        this.state.ordersCourtMade = this.form11Info.ordersCourtMade? null:false
        
        this.state.hearingDate = this.form11Info.hearingDate? null :false;

        if(dontFindInvalidFields == true) return true

        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                Vue.filter('findInvalidFields')()
                return false
            }            
        }
        return true            
    } 

    public saveForm(draft: boolean) { 
        
        let method = 'post';
        let url = '/form11/forms';

        if (this.currentOrderMultipleJusticesId){
            method = 'put';
            url = '/form11/forms/'+this.currentOrderMultipleJusticesId;
            const form11Data = this.form11Info;            
            this.UpdateForm11Info(form11Data);

            if (!draft && !this.checkStates()){               
                return                
            } 
            
            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form11Info,
                    type:'Form11',
                    description:'Order of the Court'
                }
            }
            this.saveInfo(options, draft);

        } else {
            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form11Info,
                    type:'Form11',
                    description:'Order of the Court'
                }
            }
            this.saveInfo(options, draft);
        }
    }

    public saveInfo(options, draft){

        this.$http(options)
            .then(response => {
                if(response.data){
                    if(options.method == "post"){
                        this.UpdateCurrentOrderMultipleJusticesId(response.data.file_id); 
                    }

                    this.clearStates();                                     
                    if(!draft) this.navigateToPreviewPage();                           
                }
            }, err => {
                const errMsg = err.response.data.error;                
            })
    }

    public addNewRespondent(){
        this.state.respondentsInfo = null
        this.partyToEdit = {} as form11PartiesInfoType
        this.partyType = 'Respondent'
        this.isCreate = true;
        this.showPartyWindow = true;        
    }

    public editRespondent(data) {
        this.partyToEdit = data.item
        this.partyType = 'Respondent';
        this.isCreate = false;
        this.showPartyWindow = true;
    }

    public removeRespondent(data){ 
        const form11Data = this.form11Info;       
        form11Data.respondents.splice(data.index,1);
        form11Data.respondentNames = form11Data.respondents.map(resp=>resp.name).join(', ');
        this.partyNames = [...form11Data.appellants, ...form11Data.respondents]
        this.somePartiesChanged()
        this.UpdateForm11Info(form11Data);
        this.updated ++;        
    }

    public addNewAppellant(){
        this.state.appellantsInfo = null
        this.partyToEdit = {} as form11PartiesInfoType
        this.partyType = 'Appellant'
        this.isCreate = true;
        this.showPartyWindow = true;        
    }

    public editAppellant(data) {
        this.partyToEdit = data.item
        this.partyType = 'Appellant';
        this.isCreate = false;
        this.showPartyWindow = true;        
    }

    public removeAppellant(data){   
        const form11Data = this.form11Info;       
        form11Data.appellants.splice(data.index,1); 
        form11Data.appellantNames = form11Data.appellants.map(resp=>resp.name).join(', ');
        this.partyNames = [...form11Data.appellants, ...form11Data.respondents]        
        this.somePartiesChanged()
        this.UpdateForm11Info(form11Data);
        this.updated ++;        
    }

    public partyChanged(partyCreated){
        if(partyCreated){
            const form11Info = this.form11Info
            const party = JSON.parse(JSON.stringify(this.partyToEdit))
            if(this.partyType == 'Appellant'){
                form11Info.appellants.push(party);
            }
            else if(this.partyType =='Respondent'){
                form11Info.respondents.push(party);
            }
            this.UpdateForm11Info(form11Info)
        }
        this.revaluateForm11Data();
        this.showPartyWindow = false;
        this.somePartiesChanged() 
        this.updated++;
    }

    public addNewJudgeNames(){
        if(this.isEditJudgeNamesOpen){            
            this.addJudgeNamesFormColor = 'danger'
        }else{
            this.state.judgeNames = null;
            this.AddNewJudgeNamesForm = true;            
        }
    }

    public editJudgeNames(data) {
        // console.log(data)
        if(this.AddNewJudgeNamesForm || this.isEditJudgeNamesOpen){            
            this.addJudgeNamesFormColor = 'danger';                     
        }else if(!this.isEditJudgeNamesOpen && !data.detailsShowing){
            //console.log(data);
            data.toggleDetails();
            this.isEditJudgeNamesOpen = true;
            this.latestEditJudgeNamesData = data;            
        }   
    }

    public modifyJudgeNames(isCreateJudgeNames: boolean, newJudgeName: string, index: number, otherName){        

        const form11Data = this.form11Info;

        if (isCreateJudgeNames){           
            form11Data.judgeNames.push({name: newJudgeName, other: otherName, text: (otherName?otherName:newJudgeName) })            
        } else {                    
            form11Data.judgeNames[index] = {name: newJudgeName, other: otherName, text: (otherName?otherName:newJudgeName) };        
        }
        this.UpdateForm11Info(form11Data)
        this.closeJudgeNamesForm();
        this.updated ++;
    }

    public removeJudgeNames(data){ 
        const form11Data = this.form11Info;       
        form11Data.judgeNames.splice(data.index,1);        
        this.UpdateForm11Info(form11Data);
        this.updated ++;        
    }

    public closeJudgeNamesForm() {                     
        this.AddNewJudgeNamesForm= false; 
        this.addJudgeNamesFormColor = 'court'
        if(this.isEditJudgeNamesOpen){
            this.latestEditJudgeNamesData.toggleDetails();
            this.isEditJudgeNamesOpen = false;
        }
        this.recheckStates()
    }

    public allowedDates(date){
        const day = moment().startOf('day').format('YYYY-MM-DD');
        return (date < day);           
    }

    public navigateToPreviewPage() {        
        this.$router.push({name: "preview-form11"}) 
    }

    public somePartiesChanged(){
        this.form11Info.filingParties=[]
        this.form11Info.appearingParties=[]
        this.form11Info.successfulParties = [];
        this.form11Info.unsuccessfulParties = [];
        this.updateNonSuccessfulParties();
        this.updated++;
    }

    public getCounselParty(party){

        if(party.counselName){
            const counsel: form11PartiesInfoType = JSON.parse(JSON.stringify(party))
            counsel.isCounsel = true
            counsel.name = counsel.counselName+', counsel for '+counsel.name
            return counsel
        }        
        return party
    }

    public updateNonSuccessfulParties(){
        const otherParties = [];

        if (this.partyNames.length == this.form11Info.successfulParties?.length){
            this.invalidSuccessfulParties = true;

        } else {
            this.invalidSuccessfulParties = false;

            for (const partyName of this.partyNames){
                const index = this.form11Info.successfulParties?.indexOf(partyName)
                if (index == -1){
                    otherParties.push(partyName);
                }
            }
            this.nonSuccessfulPartyNames = otherParties;
            this.updated ++;
        }      
    }


}
